import IService from '../IService';

export default IService.extend({
  curXHR: {},

  GET: function (options) {
    options = $.extend(
      {
        programmerId: null,
        url: null,
        checksum: null,
        uuid: null,
        previewId: null,
      },
      options
    );

    const promise = new $.Deferred();
    const url = app.apiUrl(
      `/api/v1/assets/${options.uuid}/previews/${options.previewId}?` +
        $.param({
          directUrl: options.url,
          _: Date.now(),
        })
    );

    if (!options || !options.url) {
      console.error('assets realtime preview GET: url not set');
    } else {
      this.curXHR[options.checksum] = $.ajax({
        url: url,
        type: 'GET',
        contentType: 'application/json',
        error: function () {
          promise.reject({ error: 'CONNECTION' });
        },
        success: function (response) {
          if ('OK' === response.response) {
            promise.resolve(response);
          } else {
            promise.reject({ error: 'NOT_READY' });
          }
        },
      }).always(() => {
        this.curXHR[options.checksum] = null;
      });
    }
    return promise;
  },

  POST: function (options) {
    options = $.extend(
      {
        assetModel: null,
        checksum: null,
        topicId: null,
        programmerId: null,
        aspectRatio: null,
        RealtimePreviewType: null,
        storyId: null,
        height: null,
      },
      options
    );

    const promise = new $.Deferred();

    if (
      !options ||
      !options.assetModel ||
      !options.programmerId ||
      !options.aspectRatio ||
      !options.themeId
    ) {
      promise.reject({ error: 'insufficient data' });
    } else {
      if (!options.topicId) {
        options.topicId = 2; // default NEWS topic
      }

      const params = {
        programmerId: options.programmerId,
        themeId: options.themeId,
        previewType: options.RealtimePreviewType,
        checksum: options.checksum,
        aspectRatio: options.aspectRatio,
        storyId: options.storyId,
      };

      if (options.height) {
        params.height = options.height;
      }

      if (!options.RealtimePreviewType) {
        options.RealtimePreviewType = app.RealtimePreviewType.VIDEO;
      }

      const version = 'v2';
      // options.RealtimePreviewType === app.RealtimePreviewType.VIDEO ||
      // options.RealtimePreviewType === app.RealtimePreviewType.VIDEO_PARTS
      //   ? 'v2'
      //   : 'v1';
      const uuid = options.assetModel.metadata.assetUUID;
      const url = app.apiUrl(
        `/api/${version}/assets/${uuid}/previews?` + $.param(params)
      );

      this.curXHR[options.checksum] = $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify({
          metaAsset: options.assetModel,
          storyCustomOverlays: options.storyCustomOverlays || [],
          language: app.storyController.story.get('storyLanguage'),
          topicId: options.topicId,
        }),
        error: function () {
          promise.reject({ error: 'CONNECTION' });
        },
        contentType: 'application/json',
        success: function (response) {
          if ('OK' === response.response) {
            promise.resolve(response);
          } else {
            promise.reject({ error: 'UNKNOWN' });
          }
        },
      }).always(() => {
        this.curXHR[options.checksum] = null;
      });
    }
    return promise;
  },

  ABORT: function (options) {
    options = $.extend(
      {
        url: null,
        checksum: null,
        uuid: null,
        previewId: null,
      },
      options
    );

    const promise = new $.Deferred();
    if (!options.checksum) {
      console.error('assets realtime preview ABORT: insufficient parameters');
    }
    if (this.curXHR[options.checksum]) {
      this.curXHR[options.checksum].abort();
      delete this.curXHR[options.checksum];
    }
    if (options.url) {
      $.ajax({
        url: app.apiUrl(
          `/api/v1/assets/${options.uuid}/previews/${options.previewId}?directUrl=${options.url}`
        ),
        type: 'DELETE',
        contentType: 'application/json',
        error: function () {
          promise.reject({ error: 'CONNECTION' });
        },
        success: function (response) {
          if ('OK' === response.response) {
            promise.resolve(response);
          } else {
            promise.reject({ error: 'NOT_READY' });
          }
        },
      });
    }
    return promise;
  },
});
